import { SET_STORE_DETAILS } from './types';

export const setStoreDetails = (storeDetails) => ({
  type: SET_STORE_DETAILS,
  payload: storeDetails,
});
